/**
 * This is a hook wrapper for the auth context
 */

import { useContext } from 'react';
import { AuthContext, type AuthContextType } from '@/contexts/auth.ctx.tsx';

export function useAuthHook(): AuthContextType {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthHook must be used within an AuthProvider');
  }
  return context;
}
